import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="m3.254 1.746c-1.299 1.883-2.013 4.062-2.203 6.254-0.1918 2.208 0.1464 4.371 1.119 6.254l0.8203-0.6953c-0.8199-1.688-1.075-3.606-0.9043-5.559 0.1698-1.941 0.7583-3.87 1.877-5.559zm10.59 0-0.8535 0.6953c0.8268 1.688 1.073 3.606 0.9023 5.559-0.1698 1.941-0.7563 3.87-1.875 5.559l0.7285 0.6953c1.299-1.883 2.01-4.062 2.201-6.254 0.1915-2.201-0.1377-4.371-1.104-6.254zm-8.117 3.1 1.539 3.332-2.721 3.512 1.416-0.007812 1.852-2.57 1.086 2.607h1.248l-1.584-3.416 2.643-3.449-1.365-0.007812-1.834 2.535-1.02-2.527z"
      fill="currentColor"
    />
  </SvgIcon>
));
